import React, { useState } from 'react';
import useTranslationService from './translationService';
import { createContext, useContext } from "react";

export const TranslationContext = createContext({});
export function useTranslation() {
    return useContext(TranslationContext);
}

export function TranslationProvider({ children }) {
    const translationMethods = useProvideTranslation();

    return (
        <TranslationContext.Provider value={translationMethods}>
            {children}
        </TranslationContext.Provider>
    );
}

function useProvideTranslation() {
    const TranslationService = useTranslationService();
    const [translations, setTranslations] = useState([]);

    const getTranslations = async (status = null) => {
        try {
            const translations = await TranslationService.getTranslations(status);
            setTranslations(translations);
        } catch (error) {
            console.error(
                'Hubo un error al intentar obtener las traducciones: ',
                error
            );
        }
    };

    const getTranslationsByUserId = async (userId) => {
        try {
            const translations = await TranslationService.getTranslationsByUserId(userId);
            setTranslations(translations);
        } catch (error) {
            console.error(
                'Hubo un error al intentar obtener las traducciones del usuario: ',
                error
            );
        }
    };

    const getTranslationsByStatus = async (status) => {
        try {
            const translations = await TranslationService.getTranslationsByStatus(status);
            setTranslations(translations);
            return translations
        } catch (error) {
            console.error(
                'Hubo un error al intentar obtener las traducciones del traductor: ',
                error
            );
        }
    };


    const getTraductors = async () => {
        try {
            const traductors = await TranslationService.getTraductors();
            return traductors
        } catch (error) {
            console.error(
                'Hubo un error al intentar obtener los traductores: ',
                error
            );
        }
    };

    const downloadExcel = async () => {
        try {
            const response = await TranslationService.downloadExcel();
            return response
        } catch (error) {
            console.error(
                'Hubo un error al intentar descargar el excel de traducciones: ',
                error
            );
        }
    };

    const downloadTranslation = async (type, folder, fileName) => {
        try {
            const response = await TranslationService.downloadTranslation(type, folder, fileName);
            return response
        } catch (error) {
            console.error(
                'Hubo un error al intentar descargar la traducción: ',
                error
            );
        }
    };

    const createTranslation = async (translation) => {
        try {
            const response = await TranslationService.createTranslation(translation);
            return response
        } catch (error) {
            console.error(
                'Hubo un error al intentar descargar la traducción: ',
                error
            );
        }
    };

    const updateTranslationFile = async (id, file) => {
        try {
            const response = await TranslationService.updateTranslationFile(id, file);
            return response
        } catch (error) {
            console.error(
                'Hubo un error al intentar subir el archivo de traducción: ',
                error
            );
        }
    };

    const updateTranslation = async (translation, id) => {
        try {
            const response = await TranslationService.updateTranslation(translation, id);
            return response
        } catch (error) {
            console.error(
                'Hubo un error al intentar actualizar el estado de la de traducción: ',
                error
            );
        }
    };

    const getTypes = async () => {
        try {
            const response = await TranslationService.getTypes();
            return response
        } catch (error) {
            console.error(
                'Hubo un error al traer los tipo de traducción: ',
                error
            );
        }
    };

    const getDepartment = async () => {
        try {
            const response = await TranslationService.getDepartment();
            return response
        } catch (error) {
            console.error(
                'Hubo un error al traer los departamentos de traducción: ',
                error
            );
        }
    };

    const getReasons = async () => {
        try {
            const response = await TranslationService.getReasons();
            return response
        } catch (error) {
            console.error(
                'Hubo un error al traer las razones de traducción: ',
                error
            );
        }
    };

    return {
        translations,
        getTranslations,
        getDepartment,
        getReasons,
        getTraductors,
        getTypes,
        downloadTranslation,
        getTranslationsByUserId,
        createTranslation,
        getTranslationsByStatus,
        updateTranslationFile,
        updateTranslation,
        downloadExcel
    };
}
